{
  "name": "Nom",
  "accountType": "Type de compte",
  "portfolio": "Portefeuille",
  "percentageOfTotalGOAL": "% de l'objectif total",
  "percentageOfTotalACCOUNT": "% du compte total",
  "balance": "Équilibre",
  "addSubAccount": "Ajouter",
  "subAccount": "Sous-comptes",
  "noLinkedSubAccountToACCOUNT": "Vous n'avez pas de sous-compte lié à ce compte",
  "noLinkedSubAccountToGOAL": "Vous n'avez pas de sous-compte lié à cet objectif",
  "reactivateSubAccount": "Réactiver le sous-compte",
  "subAccountSuccessToast": "Vous avez correctement réactivé ce sous-compte.",
  "closeSubaccountModal": {
    "title": "Fermer le sous-compte",
    "body": "Êtes-vous sûr de vouloir fermer ce sous-compte?",
    "close": "Fermer",
    "cancel": "Annuler"
  },
  "switchEquitiesModal": {
    "atCost": "Changement de l'action au prix coûtant",
    "atMarket": "Changement de l'action au prix du marché",
    "close": "Fermer",
    "cancel": "Annuler",
    "existingHolding": "Sécurité de l'interrupteur",
    "newHolding": "Sécurité de l'interrupteur",
    "date": "Date de changement",
    "description": "Description",
    "switch": "Changement",
    "errorToastMessage": "Les transactions n'ont pas été créées.",
    "sameProductToastMessage": "La sécurité de la sortie est la même que celle de l'entrée."
  },
  "editSwitchEquitiesModal": {
    "atCostTransactionsTitle": "Sortie / Entrée au prix coûtant",
    "atMarketTransactionsTitle": "Sortie / Entrée au prix du marché",
    "subAccount": "Portefeuille",
    "date": "Date",
    "switchOutSecurity": "Sécurité de l'interrupteur",
    "switchInSecurity": "Sécurité de l'interrupteur",
    "quantity": "Nombre total d'unités",
    "cost": "Coût de base ajusté par unité",
    "totalCost": "Coût total",
    "marketValuePerUnit": "Prix par unité",
    "marketValue": "Valeur marchande totale",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "invalidPriceToastMessage": "Le prix ne peut pas être de 0 $."
  },
  "status": "Statut",
  "Goal": "Objectif",
  "Account": "Compte",
  "recommended": "Recommandé:",
  "close": "Fermer",
  "subaccountStateLabel": "État du sous-compte",
  "owner": "Propriétaire"
}
